import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractStage } from '../../../models/Entities/Contracts/ContractStage';

type StagePatch = Partial<ContractStage>;

const patchStageIn = (stages: ContractStage[] | undefined, stageId: number, patch: StagePatch): ContractStage[] | undefined => {
  if (!stages?.some((stage) => stage.id === stageId)) return stages;
  return stages.map((stage) => (stage.id === stageId ? { ...stage, ...patch } as ContractStage : stage));
};

/**
 * Aplica el estado del vínculo etapa → visita en todos los lugares donde el
 * contrato guarda esa etapa: la lista por contrato (`stages`) y la de su
 * adenda. Antes sólo se tocaba la adenda, y como el drawer de visitas del
 * protocolo no conoce la adenda de la etapa, el contrato nunca se enteraba.
 */
export const applyStageLink = (contract: Contract, stageId: number, addendumId: number | undefined, patch: StagePatch): Contract => {
  const addendums = (contract.addendums || []).map((addendum: ContractAddendum) =>
    addendum.id === addendumId || addendumId === undefined
      ? { ...addendum, stages: patchStageIn(addendum.stages, stageId, patch) }
      : addendum
  );
  return {
    ...contract,
    stages: patchStageIn(contract.stages, stageId, patch),
    addendums
  } as Contract;
};

export default function ContractStageLinkVisitReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;

  const update = (patch: StagePatch): ContractState => {
    const contract = currentState.list?.find((item: Contract) => item.id === a.contractId);
    if (!contract) return currentState;
    const updated = applyStageLink(contract, a.contractStageId, a.contractAddendumId, patch);
    return {
      ...currentState,
      list: [...(currentState.list || []).filter((item: Contract) => item.id !== contract.id), updated],
    };
  };

  switch (a.type) {
    case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_REQUEST_ACTION':
      return update({
        isLinkingToAProtocolVisit: true,
        linkedToAProtocolVisitSuccessfully: undefined,
        failOnLinkingToAProtocolVisit: false,
        errorOnLinkingToAProtocolVisit: undefined,
      });
    case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_RECEIVE_ACTION':
      return update({
        isLinkingToAProtocolVisit: false,
        linkedToAProtocolVisitSuccessfully: true,
        failOnLinkingToAProtocolVisit: false,
        errorOnLinkingToAProtocolVisit: undefined,
        emrProtocolVisitIdRelated: a.protocolVisitId,
      });
    case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_FAIL_ACTION':
      return update({
        isLinkingToAProtocolVisit: false,
        linkedToAProtocolVisitSuccessfully: false,
        failOnLinkingToAProtocolVisit: true,
        errorOnLinkingToAProtocolVisit: a.error,
      });
    default:
      return currentState;
  }
}
